module.exports = __webpack_public_path__ + "static/media/iont.9ca42803.png";